import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8305ebe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  class: "poster-countdown",
  "aria-live": "polite"
}
const _hoisted_3 = {
  key: 0,
  class: "home-page"
}
const _hoisted_4 = { class: "hero-section" }
const _hoisted_5 = {
  class: "hotpot-plate",
  "aria-hidden": "true"
}
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = { class: "notice-card notice-card--hidden" }
const _hoisted_8 = { class: "notice-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "投票须知：", -1))
const _hoisted_10 = { class: "vote-status" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice-row" }, [
  /*#__PURE__*/_createElementVNode("b", null, "投票须知："),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "投票时间"),
    /*#__PURE__*/_createElementVNode("p", null, "2026年6月19日-2026年9月30日"),
    /*#__PURE__*/_createElementVNode("p", null, "（入围小吃详情请点击下方图片查看）"),
    /*#__PURE__*/_createElementVNode("p", null, "潮味+臻品每日合计3票，商户每日单独3票。"),
    /*#__PURE__*/_createElementVNode("p", null, "菜品池同一道菜每天只能投1票，商户池同一商户每天只能投1票。"),
    /*#__PURE__*/_createElementVNode("p", null, "严禁任何作弊行为，系统会进行自动监测，一经发现立即取消投票资格。")
  ])
], -1))
const _hoisted_12 = { class: "stats" }
const _hoisted_13 = { class: "rank-panel" }
const _hoisted_14 = { class: "tabs" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "food-grid"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = {
  key: 1,
  class: "image-placeholder food-image-placeholder"
}
const _hoisted_20 = { class: "food-info" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = {
  key: 1,
  class: "search-empty"
}
const _hoisted_24 = {
  key: 2,
  class: "list-state"
}
const _hoisted_25 = {
  key: 3,
  class: "list-state"
}
const _hoisted_26 = {
  key: 1,
  class: "detail-page"
}
const _hoisted_27 = { class: "detail-header" }
const _hoisted_28 = { class: "detail-card detail-info-card" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "detail-intro" }
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = {
  key: 1,
  class: "image-placeholder detail-thumb-placeholder"
}
const _hoisted_33 = {
  key: 0,
  class: "merchant-dishes-card"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "商户菜品", -1))
const _hoisted_35 = {
  key: 0,
  class: "merchant-dishes-state"
}
const _hoisted_36 = {
  key: 1,
  class: "merchant-dishes-list"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = {
  key: 1,
  class: "image-placeholder merchant-dish-placeholder"
}
const _hoisted_40 = {
  key: 2,
  class: "merchant-dishes-state"
}
const _hoisted_41 = {
  key: 1,
  class: "detail-desc"
}
const _hoisted_42 = { class: "detail-meta" }
const _hoisted_43 = { class: "detail-meta" }
const _hoisted_44 = { class: "detail-stats" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "累积票数", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前排名", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "距上一名", -1))
const _hoisted_48 = { class: "detail-card detail-image-card" }
const _hoisted_49 = ["src", "alt"]
const _hoisted_50 = {
  key: 1,
  class: "image-placeholder detail-image-placeholder"
}
const _hoisted_51 = {
  key: 2,
  class: "ranking-page"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rank-ribbon" }, [
  /*#__PURE__*/_createElementVNode("span", null, "实时排名")
], -1))
const _hoisted_53 = { class: "ranking-card" }
const _hoisted_54 = { class: "ranking-tabs" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking-tip" }, "— 只显示前100名 —", -1))
const _hoisted_57 = {
  key: 0,
  class: "top-rankers"
}
const _hoisted_58 = { class: "top-avatar" }
const _hoisted_59 = ["src", "alt"]
const _hoisted_60 = {
  key: 1,
  class: "image-placeholder top-avatar-placeholder"
}
const _hoisted_61 = { class: "ranking-list" }
const _hoisted_62 = { class: "rank-no" }
const _hoisted_63 = ["src", "alt"]
const _hoisted_64 = {
  key: 1,
  class: "image-placeholder rank-avatar-placeholder"
}
const _hoisted_65 = { class: "rank-name" }
const _hoisted_66 = {
  key: 1,
  class: "list-state"
}
const _hoisted_67 = {
  key: 2,
  class: "search-empty"
}
const _hoisted_68 = {
  key: 3,
  class: "rules-page"
}
const _hoisted_69 = { class: "rules-card" }
const _hoisted_70 = { class: "rules-title" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "活动说明", -1))
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<div class=\"rules-block\" data-v-8305ebe4><h3 data-v-8305ebe4>投票时间</h3><p class=\"rules-date\" data-v-8305ebe4>2026年6月19日-2026年9月30日</p></div><div class=\"rules-block\" data-v-8305ebe4><h3 data-v-8305ebe4>投票须知</h3><p data-v-8305ebe4>投票时间</p><p data-v-8305ebe4>2026年6月19日-2026年9月30日</p><p data-v-8305ebe4>（入围小吃详情请点击下方图片查看）</p><p class=\"rules-gap\" data-v-8305ebe4>潮味和臻品共享一个票池，每个微信账号每天合计3票。</p><p data-v-8305ebe4>商户单独一个票池，每个微信账号每天3票。</p><p data-v-8305ebe4>菜品池同一道菜每天只能投1票；商户池同一商户每天只能投1票，次日重置。</p><p data-v-8305ebe4>一天最多可投6票；保留消费记录可在每月美食评选领取礼品。</p><p data-v-8305ebe4>严禁任何作弊行为，系统会进行自动监测，一经发现立即取消投票资格。</p></div><div class=\"rules-block\" data-v-8305ebe4><h3 data-v-8305ebe4>主办单位</h3><strong data-v-8305ebe4>沪东新村街道党工委、办事处</strong></div>", 3)
const _hoisted_75 = {
  key: 4,
  class: "follow-page"
}
const _hoisted_76 = { class: "follow-poster" }
const _hoisted_77 = { class: "qr-frame" }
const _hoisted_78 = ["src"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "follow-hint" }, [
  /*#__PURE__*/_createElementVNode("span", null, "长按识别二维码"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "fingerprint-icon",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "follow-desc" }, "如无法长按识别，请保存图片后使用“微信扫一扫”识别二维码", -1))
const _hoisted_81 = {
  key: 5,
  class: "bottom-nav"
}
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "nav-content" }
const _hoisted_84 = {
  key: 0,
  class: "search-panel",
  "aria-label": "搜索"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "search-shade",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_86 = { class: "search-topbar" }
const _hoisted_87 = { class: "search-input-panel" }
const _hoisted_88 = ["onKeyup"]
const _hoisted_89 = { class: "search-results" }
const _hoisted_90 = {
  key: 0,
  class: "search-result-state"
}
const _hoisted_91 = {
  key: 0,
  class: "search-result-group"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "菜品", -1))
const _hoisted_93 = ["onClick"]
const _hoisted_94 = ["src", "alt"]
const _hoisted_95 = {
  key: 1,
  class: "search-result-placeholder"
}
const _hoisted_96 = {
  key: 1,
  class: "search-result-group"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "商户", -1))
const _hoisted_98 = ["onClick"]
const _hoisted_99 = ["src", "alt"]
const _hoisted_100 = {
  key: 1,
  class: "search-result-placeholder"
}
const _hoisted_101 = {
  key: 2,
  class: "search-result-state"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "egg-heart",
  "aria-hidden": "true"
}, "🫶", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "爱你🫶", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "小贝贝", -1))

import axios, { AxiosError } from "axios";
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import { showFailToast, showSuccessToast } from "vant";
import bgPic from '@/assets/pic/bg2.png'
import itemPic from '@/assets/pic/1.png'
import homePic from '@/assets/pic/banner.png'
import followQrImage from '@/assets/pic/ecode.png'

type PageKey = "home" | "detail" | "rank" | "rules" | "follow";
type VoteGroupKey = "taste" | "merchant";
type VoteTargetType = "dish" | "merchant";

interface FoodItem {
  id: number;
  itemType: VoteTargetType;
  rank: number;
  code: string;
  name: string;
  votes: number;
  image: string;
  desc: string;
  address: string;
  gap: number;
  categoryId?: number;
  categoryName?: string;
  merchantId?: number;
  merchantName?: string;
  myVotes?: number;
  myVotedToday?: boolean;
}

interface RankItem {
  rank: number;
  id: number;
  name: string;
  image: string;
  votes: number;
  address?: string;
  merchantName?: string;
  categoryId?: number;
}

interface CategoryTab {
  id: number;
  text: string;
}

interface ApiResponse<T> {
  code: number;
  message: string;
  data: T;
}

interface ApiPage<T> {
  data: T[];
  total: number;
  current_page: number;
  per_page: number;
}

interface ApiCategory {
  id: number;
  name: string;
}

interface ApiStats {
  merchant_count: number;
  total_votes: number;
  visit_count: number;
}

interface VoteGroupInfo {
  categories: number[];
  daily_limit: number;
  used_today: number;
  remaining: number;
  voted_dish_ids: number[];
  voted_merchant_ids: number[];
}

interface ApiVoteGroupInfo {
  categories?: Array<number | string>;
  daily_limit?: number;
  used_today?: number;
  remaining?: number;
  voted_dish_ids?: Array<number | string>;
  voted_merchant_ids?: Array<number | string>;
}

interface ApiMyVoteData {
  groups?: Partial<Record<VoteGroupKey, ApiVoteGroupInfo>>;
  daily_limit?: number;
  used_today?: number;
  remaining?: number;
  voted_dish_ids?: Array<number | string>;
  voted_merchant_ids?: Array<number | string>;
}

interface ApiDish {
  id: number;
  name: string;
  image?: string | null;
  intro: string;
  address?: string;
  category_id: number;
  category_name: string;
  merchant_id: number;
  merchant_name?: string;
  vote_count: number;
  voter_count: number;
  my_votes?: number;
}

interface ApiMerchant {
  id: number;
  name: string;
  image?: string | null;
  intro?: string;
  phone?: string;
  address?: string;
  vote_count: number;
  my_voted_today?: boolean;
}

interface ApiSearchDish extends ApiDish {
  type: "dish";
}

interface ApiSearchMerchant extends ApiMerchant {
  type: "merchant";
}

interface ApiSearchResult {
  dishes: ApiSearchDish[];
  merchants: ApiSearchMerchant[];
}

interface ApiRankingItem {
  rank: number;
  id: number;
  name: string;
  image?: string | null;
  address?: string;
  votes: number;
  merchant_name?: string;
  category_id?: number;
}

interface VoteSubmitData {
  remaining?: number;
  daily_limit?: number;
  groups?: Partial<Record<VoteGroupKey, ApiVoteGroupInfo>>;
}

interface VoteUploadTokenData {
  host: string;
  dir: string;
  domain: string;
  expire: number;
  policy: string;
  "q-sign-algorithm": string;
  "q-ak": string;
  "q-key-time": string;
  "q-signature": string;
  success_action_status: number;
}

interface VoteApiError extends Error {
  code?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const VOTE_API_BASE_URL = "https://cook.renliewangluo.com";
const WECHAT_APP_ID = "wx43115a14a8f6690b";
const VOTE_TOKEN_KEY = "food_vote_token";
const PENDING_VOTE_DISH_KEY = "food_vote_pending_dish_id";
const PENDING_VOTE_TARGET_KEY = "food_vote_pending_target";
const PAGE_SIZE = 20;
const SEARCH_SUGGEST_DEBOUNCE_DELAY = 300;
const MERCHANT_CATEGORY_ID = 3;
const MERCHANT_CATEGORY_TAB: CategoryTab = { id: MERCHANT_CATEGORY_ID, text: "人气商户" };
const VOTE_START_TIME = new Date(2026, 5, 19, 0, 0, 0).getTime();
const VOTE_END_TIME = new Date(2026, 8, 30, 23, 59, 59).getTime();

const activePage = ref<PageKey>("home");
const isScrolled = ref(false);
const showPoster = ref(true);
const posterCountdown = ref(3);
const currentTimestamp = ref(Date.now());
const isSearchActive = ref(false);
const searchKeyword = ref("");
const appliedSearchKeyword = ref("");
const searchInputRef = ref<HTMLInputElement | null>(null);
const isSearchSuggestLoading = ref(false);
const searchSuggestResults = ref<ApiSearchResult>({ dishes: [], merchants: [] });
const merchantDishes = ref<FoodItem[]>([]);
const isMerchantDishLoading = ref(false);
const showEasterEgg = ref(false);
const activeCategoryId = ref(1);
const activeRankingCategoryId = ref(1);
const categoryTabs = ref<CategoryTab[]>([
  { id: 1, text: "潮味小吃" },
  { id: 2, text: "臻品美食" },
  MERCHANT_CATEGORY_TAB,
]);
const apiStats = ref<ApiStats>({
  merchant_count: 32,
  total_votes: 4972,
  visit_count: 6540,
});
const authToken = ref("");
const isDishLoading = ref(false);
const isDishFinished = ref(false);
const isRankingLoading = ref(false);
const isVoting = ref(false);
const myVoteGroups = ref<Partial<Record<VoteGroupKey, VoteGroupInfo>>>({});

const posterImage = bgPic;
// const followQrImage =
//   "https://api.qrserver.com/v1/create-qr-code/?size=420x420&margin=12&data=https%3A%2F%2Fwww.example.com%2Ffollow";

const stats = computed(() => [
  { label: "入围商户", value: String(apiStats.value.merchant_count) },
  { label: "累计投票", value: String(apiStats.value.total_votes) },
  { label: "访问人数", value: String(apiStats.value.visit_count) },
]);

const fallbackFoods: FoodItem[] = [
  {
    id: 1,
    itemType: "dish",
    rank: 1,
    code: "01",
    name: "小孟煎饼",
    votes: 756,
    image: itemPic,
    desc: "薄薄的煎饼再加上脆脆的炸片，咬上一口，美味酥脆，加甜面酱，回味无穷。",
    address: "环城东路515号",
    gap: 0,
  },
  {
    id: 2,
    itemType: "dish",
    rank: 3,
    code: "02",
    name: "多多米线",
    votes: 674,
    image: itemPic,
    desc: "米线爽滑入味，汤底鲜香浓郁，搭配丰富小料，热气腾腾更显满足。",
    address: "南桥镇人民中路218号",
    gap: 82,
  },
  {
    id: 3,
    itemType: "dish",
    rank: 27,
    code: "03",
    name: "牛肉汤面",
    votes: 421,
    image:itemPic,
    desc: "牛肉软烂醇香，面条筋道顺滑，汤头厚实，是街巷里暖胃的一碗。",
    address: "奉浦街道环城西路96号",
    gap: 107,
  },
  {
    id: 4,
    itemType: "dish",
    rank: 8,
    code: "04",
    name: "芝麻烧饼",
    votes: 528,
    image:itemPic,
    desc: "外皮焦香酥脆，芝麻香气充足，入口层次分明，越嚼越香。",
    address: "奉城镇川南奉公路128号",
    gap: 15,
  },
];

const foods = ref<FoodItem[]>(fallbackFoods);
const selectedFood = ref<FoodItem>(fallbackFoods[0]);
const dishPage = ref(1);
const dishTotal = ref(0);

const fallbackRankingItems: RankItem[] = [
  { rank: 1, id: 1, name: "小孟煎饼", votes: 756, image: fallbackFoods[0].image },
  { rank: 2, id: 2, name: "多多米线", votes: 674, image: fallbackFoods[1].image },
  { rank: 3, id: 3, name: "四团青菜腊肉面", votes: 418, image: fallbackFoods[2].image },
  { rank: 4, id: 4, name: "头桥火炉饼", votes: 410, image: fallbackFoods[3].image },
  {
    rank: 5,
    id: 5,
    name: "陈家热气羊肉",
    votes: 327,
    image: "https://images.unsplash.com/photo-1529692236671-f1f6cf9683ba?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 6,
    id: 6,
    name: "缙云梅干菜烧饼",
    votes: 283,
    image: "https://images.unsplash.com/photo-1586444248902-2f64eddc13df?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 7,
    id: 7,
    name: "阿平生煎",
    votes: 231,
    image: "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 8,
    id: 8,
    name: "奉城羊肉面",
    votes: 215,
    image: "https://images.unsplash.com/photo-1582878826629-29b7ad1cdc43?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 9,
    id: 9,
    name: "木瑶小屋茶果子",
    votes: 212,
    image: "https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 10,
    id: 10,
    name: "木屋红烧肉",
    votes: 210,
    image: "https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 11,
    id: 11,
    name: "红烩水库大鱼头",
    votes: 185,
    image: "https://images.unsplash.com/photo-1569058242253-92a9c755a0ec?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 12,
    id: 12,
    name: "海湾农垦包",
    votes: 139,
    image: "https://images.unsplash.com/photo-1563245372-f21724e3856d?auto=format&fit=crop&w=240&q=80",
  },
];

const rankingItems = ref<RankItem[]>(fallbackRankingItems);

const navItems: Array<{ key: PageKey; text: string; icon: string }> = [
  { key: "rank", text: "排行榜", icon: "medal-o" },
  { key: "rules", text: "活动说明", icon: "notes-o" },
  { key: "follow", text: "关注我们", icon: "like-o" },
];

const homeNavText = computed(() => (activePage.value === "home" && isScrolled.value ? "返回顶部" : "首页"));
const homeNavIcon = computed(() => (activePage.value === "home" && isScrolled.value ? "back-top" : "wap-home-o"));
const homeNavKey = computed(() => `${homeNavIcon.value}-${homeNavText.value}`);
const detailFood = computed(() => selectedFood.value);
const searchDraftKeyword = computed(() => searchKeyword.value.trim());
const normalizedSearchKeyword = computed(() => appliedSearchKeyword.value.trim());
const hasChangedSearchDraft = computed(() => {
  return Boolean(searchDraftKeyword.value) && searchDraftKeyword.value !== normalizedSearchKeyword.value;
});
const hasSearchSuggestResults = computed(() => {
  return searchSuggestResults.value.dishes.length > 0 || searchSuggestResults.value.merchants.length > 0;
});
const searchActionText = computed(() => (hasChangedSearchDraft.value ? "搜索" : "取消"));
const searchBoxText = computed(() => normalizedSearchKeyword.value || "请输入名称搜索");
const voteCountdownText = computed(() => {
  if (currentTimestamp.value < VOTE_START_TIME) {
    return "投票未开始";
  }
  if (currentTimestamp.value > VOTE_END_TIME) {
    return "投票已结束";
  }

  const remainingMinutes = Math.max(0, Math.ceil((VOTE_END_TIME - currentTimestamp.value) / 60000));
  const days = Math.floor(remainingMinutes / 1440);
  const hours = Math.floor((remainingMinutes % 1440) / 60);
  const minutes = remainingMinutes % 60;
  return `距离投票结束还有 ${days}天${hours}小时${minutes}分钟`;
});
const topRankers = computed(() => {
  const topThree = rankingItems.value.slice(0, 3);
  if (topThree.length >= 3) {
    return [topThree[1], topThree[0], topThree[2]];
  }
  return topThree;
});
const remainingRankers = computed(() => rankingItems.value.slice(3));

let scrollFrame = 0;
let foodRequestId = 0;
let searchSuggestRequestId = 0;
let searchSuggestTimer = 0;
let merchantDishRequestId = 0;
let posterTimer = 0;
let posterCountdownTimer = 0;
let voteCountdownTimer = 0;
let homePicTapCount = 0;
let homePicTapTimer = 0;
let lastHomePicTapTime = 0;
let hasLoadedVoteData = false;
let originalBodyOverflow = "";

const getLocalToken = () => window.localStorage.getItem(VOTE_TOKEN_KEY) || "";

const setLocalToken = (token: string) => {
  authToken.value = token;
  window.localStorage.setItem(VOTE_TOKEN_KEY, token);
};

const clearLocalToken = () => {
  authToken.value = "";
  myVoteGroups.value = {};
  window.localStorage.removeItem(VOTE_TOKEN_KEY);
};

const getHashParam = (key: string) => {
  const hash = window.location.hash || "";
  const queryIndex = hash.indexOf("?");
  if (queryIndex < 0) return null;
  return new URLSearchParams(hash.slice(queryIndex + 1)).get(key);
};

const getUrlParam = (key: string) => {
  return new URLSearchParams(window.location.search).get(key) || getHashParam(key);
};

const cleanAuthParamsFromUrl = () => {
  const url = new URL(window.location.href);
  let changed = false;

  ["token", "auth_error"].forEach((key) => {
    if (url.searchParams.has(key)) {
      url.searchParams.delete(key);
      changed = true;
    }
  });

  const hash = url.hash || "";
  const queryIndex = hash.indexOf("?");
  if (queryIndex >= 0) {
    const hashPath = hash.slice(0, queryIndex);
    const hashParams = new URLSearchParams(hash.slice(queryIndex + 1));
    ["token", "auth_error"].forEach((key) => {
      if (hashParams.has(key)) {
        hashParams.delete(key);
        changed = true;
      }
    });
    const nextHashQuery = hashParams.toString();
    url.hash = nextHashQuery ? `${hashPath}?${nextHashQuery}` : hashPath;
  }

  if (changed) {
    window.history.replaceState(null, document.title, `${url.pathname}${url.search}${url.hash}`);
  }
};

const syncAuthFromUrl = () => {
  const authError = getUrlParam("auth_error");
  const token = getUrlParam("token");

  if (token) {
    setLocalToken(token);
  } else {
    authToken.value = getLocalToken();
  }

  if (authError) {
    window.localStorage.removeItem(PENDING_VOTE_DISH_KEY);
    window.localStorage.removeItem(PENDING_VOTE_TARGET_KEY);
    showFailToast("微信授权未完成，请重新投票授权");
  }

  if (token || authError) {
    cleanAuthParamsFromUrl();
  }
};

const getCleanRedirectUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete("token");
  url.searchParams.delete("auth_error");

  const hash = url.hash || "#/";
  const queryIndex = hash.indexOf("?");
  if (queryIndex >= 0) {
    const hashPath = hash.slice(0, queryIndex);
    const hashParams = new URLSearchParams(hash.slice(queryIndex + 1));
    hashParams.delete("token");
    hashParams.delete("auth_error");
    const nextHashQuery = hashParams.toString();
    url.hash = nextHashQuery ? `${hashPath}?${nextHashQuery}` : hashPath;
  }

  return url.toString();
};

const redirectToWechatAuth = () => {
  const authUrl = new URL(`${VOTE_API_BASE_URL}/wechat/official/auth`);
  authUrl.searchParams.set("redirect_url", getCleanRedirectUrl());
  authUrl.searchParams.set("scope", "snsapi_userinfo");
  authUrl.searchParams.set("appid", WECHAT_APP_ID);
  window.location.href = authUrl.toString();
};

const getErrorMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ApiResponse<unknown>>;
    return axiosError.response?.data?.message || axiosError.message || "请求失败";
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "请求失败";
};

const voteRequest = async <T,>(url: string, data: Record<string, unknown> = {}, needAuth = false) => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (authToken.value) {
    headers.Authorization = `Bearer ${authToken.value}`;
  } else if (needAuth) {
    const error = new Error("请先完成微信授权") as VoteApiError;
    error.code = 401;
    throw error;
  }

  const response = await axios.post<ApiResponse<T>>(`${VOTE_API_BASE_URL}${url}`, data, { headers });
  const responseData = response.data;
  if (responseData.code !== 200) {
    const error = new Error(responseData.message || "请求失败") as VoteApiError;
    error.code = responseData.code;
    throw error;
  }

  return responseData.data;
};

const getFileExtension = (file: File) => {
  const nameExt = file.name.split(".").pop();
  if (nameExt) return nameExt.toLowerCase();

  const mimeExt = file.type.split("/").pop();
  return mimeExt || "jpg";
};

const fetchVoteUploadToken = () => {
  return voteRequest<VoteUploadTokenData>("/wechat/official/vote/uploadToken", {}, true);
};

const uploadReceiptImage = async (file: File) => {
  const token = await fetchVoteUploadToken();
  const key = `${token.dir}${Date.now()}-${Math.random().toString(36).slice(2, 10)}.${getFileExtension(file)}`;
  const formData = new FormData();
  formData.append("key", key);
  formData.append("policy", token.policy);
  formData.append("q-sign-algorithm", token["q-sign-algorithm"]);
  formData.append("q-ak", token["q-ak"]);
  formData.append("q-key-time", token["q-key-time"]);
  formData.append("q-signature", token["q-signature"]);
  formData.append("success_action_status", String(token.success_action_status || 200));
  formData.append("file", file);

  await axios.post(token.host, formData);
  return `${token.domain.replace(/\/$/, "")}/${key}`;
};

const formatCategoryText = (name: string) => {
  if (name.includes("潮味")) return "潮味小吃";
  if (name.includes("臻品")) return "臻品美食";
  if (name.includes("商户")) return "人气商户";
  return name;
};

const normalizeImageUrl = (image?: string | null) => (typeof image === "string" ? image.trim() : "");

const mapDishToFood = (dish: ApiDish, index: number, page: number): FoodItem => {
  const fallbackCode = String(dish.id).padStart(2, "0");

  return {
    id: dish.id,
    itemType: "dish",
    rank: (page - 1) * PAGE_SIZE + index + 1,
    code: fallbackCode,
    name: dish.name,
    votes: Number(dish.vote_count || 0),
    image: normalizeImageUrl(dish.image),
    desc: dish.intro || "",
    address: dish.address || dish.merchant_name || "",
    gap: 0,
    categoryId: dish.category_id,
    categoryName: dish.category_name,
    merchantId: dish.merchant_id,
    merchantName: dish.merchant_name,
    myVotes: dish.my_votes,
  };
};

const mapMerchantToFood = (merchant: ApiMerchant, index: number, page: number): FoodItem => {
  const fallbackCode = String(merchant.id).padStart(2, "0");

  return {
    id: merchant.id,
    itemType: "merchant",
    rank: (page - 1) * PAGE_SIZE + index + 1,
    code: fallbackCode,
    name: merchant.name,
    votes: Number(merchant.vote_count || 0),
    image: normalizeImageUrl(merchant.image),
    desc: merchant.intro || "",
    address: merchant.address || "",
    gap: 0,
    categoryId: MERCHANT_CATEGORY_ID,
    categoryName: "商户",
    merchantId: merchant.id,
    merchantName: merchant.name,
    myVotedToday: Boolean(merchant.my_voted_today),
  };
};

const mapSearchDishToFood = (dish: ApiSearchDish): FoodItem => ({
  id: dish.id,
  itemType: "dish",
  rank: 0,
  code: String(dish.id).padStart(2, "0"),
  name: dish.name,
  votes: Number(dish.vote_count || 0),
  image: normalizeImageUrl(dish.image),
  desc: dish.intro || "",
  address: dish.address || dish.merchant_name || "",
  gap: 0,
  categoryId: dish.category_id,
  categoryName: dish.category_name,
  merchantId: dish.merchant_id,
  merchantName: dish.merchant_name,
});

const mapSearchMerchantToFood = (merchant: ApiSearchMerchant): FoodItem => ({
  id: merchant.id,
  itemType: "merchant",
  rank: 0,
  code: String(merchant.id).padStart(2, "0"),
  name: merchant.name,
  votes: Number(merchant.vote_count || 0),
  image: normalizeImageUrl(merchant.image),
  desc: merchant.intro || "",
  address: merchant.address || "",
  gap: 0,
  categoryId: MERCHANT_CATEGORY_ID,
  categoryName: "商户",
  merchantId: merchant.id,
  merchantName: merchant.name,
  myVotedToday: Boolean(merchant.my_voted_today),
});

const mapRankingToRankItem = (item: ApiRankingItem): RankItem => ({
  rank: item.rank,
  id: item.id,
  name: item.name,
  image: normalizeImageUrl(item.image),
  votes: Number(item.votes || 0),
  address: item.address,
  merchantName: item.merchant_name,
  categoryId: item.category_id ?? activeRankingCategoryId.value,
});

const normalizeIds = (ids?: Array<number | string>) => {
  if (!Array.isArray(ids)) return [];
  return ids.map((id) => Number(id)).filter((id) => Number.isFinite(id));
};

const normalizeMerchantIds = (ids?: Array<number | string>) => {
  return normalizeIds(ids);
};

const normalizeCategoryIds = (ids?: Array<number | string>) => {
  return normalizeIds(ids);
};

const normalizeVoteGroup = (group?: ApiVoteGroupInfo): VoteGroupInfo => ({
  categories: normalizeCategoryIds(group?.categories),
  daily_limit: Number(group?.daily_limit || 0),
  used_today: Number(group?.used_today || 0),
  remaining: Number(group?.remaining || 0),
  voted_dish_ids: normalizeIds(group?.voted_dish_ids),
  voted_merchant_ids: normalizeMerchantIds(group?.voted_merchant_ids),
});

const normalizeMyVoteGroups = (data?: ApiMyVoteData): Partial<Record<VoteGroupKey, VoteGroupInfo>> => {
  if (data?.groups) {
    return {
      taste: data.groups.taste ? normalizeVoteGroup(data.groups.taste) : undefined,
      merchant: data.groups.merchant ? normalizeVoteGroup(data.groups.merchant) : undefined,
    };
  }

  if (!data) return {};

  const legacyGroup = normalizeVoteGroup({
    categories: [1, 2],
    daily_limit: data.daily_limit,
    used_today: data.used_today,
    remaining: data.remaining,
    voted_dish_ids: data.voted_dish_ids,
    voted_merchant_ids: data.voted_merchant_ids,
  });
  return {
    taste: legacyGroup,
    merchant: {
      ...legacyGroup,
      categories: [3],
    },
  };
};

const getFoodVoteGroupKey = (food?: FoodItem): VoteGroupKey => {
  if (food?.itemType === "merchant") {
    return "merchant";
  }

  if (food?.categoryId) {
    const matchedGroup = (Object.entries(myVoteGroups.value) as Array<[VoteGroupKey, VoteGroupInfo | undefined]>).find(
      ([, group]) => group?.categories.includes(food.categoryId as number)
    );
    if (matchedGroup) {
      return matchedGroup[0];
    }
  }

  const categoryText =
    food?.categoryName || categoryTabs.value.find((item) => item.id === food?.categoryId)?.text || "";
  if (food?.categoryId === MERCHANT_CATEGORY_ID || categoryText.includes("商户")) {
    return "merchant";
  }
  return "taste";
};

const getFoodVoteGroup = (food?: FoodItem) => myVoteGroups.value[getFoodVoteGroupKey(food)];

const findFoodByTarget = (targetType: VoteTargetType, targetId: number) => {
  if (selectedFood.value.itemType === targetType && selectedFood.value.id === targetId) return selectedFood.value;
  return foods.value.find((food) => food.itemType === targetType && food.id === targetId);
};

const getSubmitRemaining = (result: VoteSubmitData, food?: FoodItem) => {
  if (typeof result.remaining === "number") return result.remaining;

  const submitGroup = result.groups?.[getFoodVoteGroupKey(food)];
  if (typeof submitGroup?.remaining === "number") return Number(submitGroup.remaining);

  const latestGroup = getFoodVoteGroup(food);
  return latestGroup?.remaining;
};

const getFoodVoteDisabledReason = (food?: FoodItem) => {
  const group = getFoodVoteGroup(food);
  if (!group) return "";

  if (group.remaining <= 0) {
    return "该类目今日票数已用完";
  }

  if (food?.itemType === "merchant") {
    if (food.myVotedToday || (food.merchantId && group.voted_merchant_ids.includes(food.merchantId))) {
      return "今天已经给该商户投过票啦";
    }
    return "";
  }

  if (food?.id && group.voted_dish_ids.includes(food.id)) {
    return "今天已经投过这道菜啦";
  }

  return "";
};

const isFoodVoteDisabled = (food?: FoodItem) => Boolean(getFoodVoteDisabledReason(food));

const getVoteButtonText = (food?: FoodItem) => {
  const reason = getFoodVoteDisabledReason(food);
  if (reason === "该类目今日票数已用完") return "今日已满";
  if (reason === "今天已经投过这道菜啦") return "已投过";
  if (reason === "今天已经给该商户投过票啦") return "已投过";
  return "投 票";
};

const canSubmitVote = (food?: FoodItem) => {
  const reason = getFoodVoteDisabledReason(food);
  if (reason) {
    showFailToast(reason);
    return false;
  }
  return true;
};

const setPendingVoteTarget = (food: FoodItem) => {
  window.localStorage.setItem(
    PENDING_VOTE_TARGET_KEY,
    JSON.stringify({
      type: food.itemType,
      id: food.id,
    })
  );
  window.localStorage.removeItem(PENDING_VOTE_DISH_KEY);
};

const getPendingVoteTarget = (): { type: VoteTargetType; id: number } | null => {
  const rawTarget = window.localStorage.getItem(PENDING_VOTE_TARGET_KEY);
  if (rawTarget) {
    try {
      const parsedTarget = JSON.parse(rawTarget) as { type?: VoteTargetType; id?: number | string };
      const targetId = Number(parsedTarget.id);
      if ((parsedTarget.type === "dish" || parsedTarget.type === "merchant") && targetId) {
        return {
          type: parsedTarget.type,
          id: targetId,
        };
      }
    } catch (error) {
      window.localStorage.removeItem(PENDING_VOTE_TARGET_KEY);
    }
  }

  const legacyDishId = Number(window.localStorage.getItem(PENDING_VOTE_DISH_KEY));
  if (legacyDishId) {
    return {
      type: "dish",
      id: legacyDishId,
    };
  }

  return null;
};

const createPendingFoodTarget = (target: { type: VoteTargetType; id: number }): FoodItem => ({
  id: target.id,
  itemType: target.type,
  rank: 0,
  code: String(target.id).padStart(2, "0"),
  name: "",
  votes: 0,
  image: itemPic,
  desc: "",
  address: "",
  gap: 0,
  categoryId: target.type === "merchant" ? MERCHANT_CATEGORY_ID : activeCategoryId.value,
  categoryName: target.type === "merchant" ? "商户" : "",
  merchantId: target.type === "merchant" ? target.id : undefined,
});

const fetchStats = async () => {
  try {
    apiStats.value = await voteRequest<ApiStats>("/wechat/official/vote/stats");
  } catch (error) {
    showFailToast(getErrorMessage(error));
  }
};

const fetchSearchSuggest = async () => {
  const keyword = searchDraftKeyword.value;
  const requestId = ++searchSuggestRequestId;

  if (!keyword) {
    isSearchSuggestLoading.value = false;
    searchSuggestResults.value = { dishes: [], merchants: [] };
    return;
  }

  isSearchSuggestLoading.value = true;
  try {
    const data = await voteRequest<ApiSearchResult>("/wechat/official/vote/search", {
      name: keyword,
      size: 20,
    });
    if (requestId !== searchSuggestRequestId) return;
    searchSuggestResults.value = {
      dishes: Array.isArray(data.dishes) ? data.dishes : [],
      merchants: Array.isArray(data.merchants) ? data.merchants : [],
    };
  } catch (error) {
    if (requestId !== searchSuggestRequestId) return;
    searchSuggestResults.value = { dishes: [], merchants: [] };
    showFailToast(getErrorMessage(error));
  } finally {
    if (requestId === searchSuggestRequestId) {
      isSearchSuggestLoading.value = false;
    }
  }
};

const scheduleSearchSuggest = () => {
  if (searchSuggestTimer) {
    window.clearTimeout(searchSuggestTimer);
  }
  searchSuggestTimer = window.setTimeout(() => {
    searchSuggestTimer = 0;
    void fetchSearchSuggest();
  }, SEARCH_SUGGEST_DEBOUNCE_DELAY);
};

const fetchCategories = async () => {
  try {
    const categories = await voteRequest<ApiCategory[]>("/wechat/official/vote/categories");
    if (!categories.length) {
      categoryTabs.value = [
        { id: 1, text: "潮味小吃" },
        { id: 2, text: "臻品美食" },
        MERCHANT_CATEGORY_TAB,
      ];
      return;
    }

    const dishTabs = categories.map((item) => ({
      id: item.id,
      text: formatCategoryText(item.name),
    }));
    categoryTabs.value = [...dishTabs, MERCHANT_CATEGORY_TAB];

    if (!categoryTabs.value.some((item) => item.id === activeCategoryId.value)) {
      activeCategoryId.value = categoryTabs.value[0].id;
    }
    if (!categoryTabs.value.some((item) => item.id === activeRankingCategoryId.value)) {
      activeRankingCategoryId.value = categoryTabs.value[0].id;
    }
  } catch (error) {
    showFailToast(getErrorMessage(error));
  }
};

const fetchRanking = async () => {
  isRankingLoading.value = true;
  try {
    const list = await voteRequest<ApiRankingItem[]>("/wechat/official/vote/ranking", {
      category_id: activeRankingCategoryId.value,
      size: 100,
    });
    rankingItems.value = list.map(mapRankingToRankItem);
  } catch (error) {
    showFailToast(getErrorMessage(error));
    if (!rankingItems.value.length) {
      rankingItems.value = fallbackRankingItems;
    }
  } finally {
    isRankingLoading.value = false;
  }
};

const fetchMyVote = async (options: { silent?: boolean } = {}) => {
  if (!authToken.value) return;

  try {
    const myVote = await voteRequest<ApiMyVoteData>("/wechat/official/vote/my", {}, true);
    myVoteGroups.value = normalizeMyVoteGroups(myVote);
  } catch (error) {
    const apiError = error as VoteApiError;
    if (apiError.code === 401) {
      clearLocalToken();
      return;
    }
    if (!options.silent) {
      showFailToast(getErrorMessage(error));
    }
  }
};

const isMerchantCategory = (categoryId: number) => categoryId === MERCHANT_CATEGORY_ID;

const getPageList = <T,>(data: ApiPage<T> | T[]) => {
  if (Array.isArray(data)) {
    return {
      list: data,
      total: data.length,
      currentPage: 1,
      perPage: data.length || PAGE_SIZE,
    };
  }

  return {
    list: data.data,
    total: Number(data.total || data.data.length),
    currentPage: Number(data.current_page || 1),
    perPage: Number(data.per_page || PAGE_SIZE),
  };
};

const maybeLoadMoreFoods = () => {
  if (activePage.value !== "home" || showPoster.value || isDishLoading.value || isDishFinished.value) return;

  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
  if (documentHeight - getScrollTop() - viewportHeight <= 260) {
    void loadFoods();
  }
};

const loadFoods = async (options: { reset?: boolean } = {}) => {
  const reset = Boolean(options.reset);
  if (!reset && (isDishLoading.value || isDishFinished.value)) return;

  const page = reset ? 1 : dishPage.value;
  const requestId = ++foodRequestId;
  isDishLoading.value = true;

  try {
    const params: Record<string, unknown> = {
      page,
      size: PAGE_SIZE,
    };
    if (normalizedSearchKeyword.value) {
      params.name = normalizedSearchKeyword.value;
    }

    if (!isMerchantCategory(activeCategoryId.value)) {
      params.category_id = activeCategoryId.value;
    }

    const requestUrl = isMerchantCategory(activeCategoryId.value)
      ? "/wechat/official/vote/merchants"
      : "/wechat/official/vote/dishes";
    const pageData = isMerchantCategory(activeCategoryId.value)
      ? await voteRequest<ApiPage<ApiMerchant> | ApiMerchant[]>(requestUrl, params)
      : await voteRequest<ApiPage<ApiDish>>(requestUrl, params);
    if (requestId !== foodRequestId) return;

    const normalizedPage = getPageList(pageData);
    const nextFoods = isMerchantCategory(activeCategoryId.value)
      ? (normalizedPage.list as ApiMerchant[]).map((merchant, index) => mapMerchantToFood(merchant, index, page))
      : (normalizedPage.list as ApiDish[]).map((dish, index) => mapDishToFood(dish, index, page));
    foods.value = reset ? nextFoods : [...foods.value, ...nextFoods];
    dishTotal.value = normalizedPage.total || foods.value.length;
    dishPage.value = normalizedPage.currentPage + 1;
    isDishFinished.value =
      foods.value.length >= dishTotal.value || nextFoods.length < normalizedPage.perPage;
  } catch (error) {
    if (requestId !== foodRequestId) return;
    showFailToast(getErrorMessage(error));
    if (reset && !foods.value.length) {
      foods.value = fallbackFoods;
    }
    isDishFinished.value = true;
  } finally {
    if (requestId !== foodRequestId) return;
    isDishLoading.value = false;
    await nextTick();
    maybeLoadMoreFoods();
  }
};

const loadMerchantDishes = async (merchantId: number) => {
  const requestId = ++merchantDishRequestId;
  isMerchantDishLoading.value = true;
  merchantDishes.value = [];

  try {
    const pageData = await voteRequest<ApiPage<ApiDish>>("/wechat/official/vote/dishes", {
      page: 1,
      size: 20,
      merchant_id: merchantId,
    });
    if (requestId !== merchantDishRequestId) return;
    const normalizedPage = getPageList(pageData);
    merchantDishes.value = (normalizedPage.list as ApiDish[]).map((dish, index) => mapDishToFood(dish, index, 1));
  } catch (error) {
    if (requestId !== merchantDishRequestId) return;
    merchantDishes.value = [];
    showFailToast(getErrorMessage(error));
  } finally {
    if (requestId === merchantDishRequestId) {
      isMerchantDishLoading.value = false;
    }
  }
};

const reportVisit = async () => {
  if (!authToken.value) return;
  try {
    await voteRequest<unknown>("/wechat/official/vote/visit", {}, true);
  } catch (error) {
    if ((error as VoteApiError).code === 401) {
      clearLocalToken();
    }
  }
};

const updateLocalVoteCount = (targetFood: FoodItem) => {
  foods.value = foods.value.map((food) => {
    if (food.itemType !== targetFood.itemType || food.id !== targetFood.id) return food;
    return {
      ...food,
      votes: food.votes + 1,
      myVotes: food.itemType === "dish" ? (food.myVotes || 0) + 1 : food.myVotes,
      myVotedToday: food.itemType === "merchant" ? true : food.myVotedToday,
    };
  });

  if (selectedFood.value.itemType === targetFood.itemType && selectedFood.value.id === targetFood.id) {
    selectedFood.value = {
      ...selectedFood.value,
      votes: selectedFood.value.votes + 1,
      myVotes: selectedFood.value.itemType === "dish" ? (selectedFood.value.myVotes || 0) + 1 : selectedFood.value.myVotes,
      myVotedToday: selectedFood.value.itemType === "merchant" ? true : selectedFood.value.myVotedToday,
    };
  }
};

const submitVote = async (food: FoodItem, receiptImage = "") => {
  if (isVoting.value) return;
  if (!canSubmitVote(food)) return;

  isVoting.value = true;

  try {
    const submitParams: Record<string, unknown> =
      food.itemType === "merchant" ? { merchant_id: food.merchantId || food.id } : { dish_id: food.id };
    if (receiptImage) {
      submitParams.receipt_image = receiptImage;
    }

    const result = await voteRequest<VoteSubmitData>("/wechat/official/vote/submit", submitParams, true);
    window.localStorage.removeItem(PENDING_VOTE_DISH_KEY);
    window.localStorage.removeItem(PENDING_VOTE_TARGET_KEY);
    updateLocalVoteCount(food);
    myVoteGroups.value = {
      ...myVoteGroups.value,
      ...normalizeMyVoteGroups(result),
    };
    await fetchMyVote({ silent: true });
    const remaining = getSubmitRemaining(result, food);
    showSuccessToast(typeof remaining === "number" ? `投票成功，今日剩余${remaining}票` : "投票成功");
    void fetchStats();
    if (activePage.value === "rank") {
      void fetchRanking();
    }
  } catch (error) {
    const apiError = error as VoteApiError;
    if (apiError.code === 401) {
      setPendingVoteTarget(food);
      clearLocalToken();
      redirectToWechatAuth();
      return;
    }
    void fetchMyVote({ silent: true });
    showFailToast(getErrorMessage(error));
  } finally {
    isVoting.value = false;
  }
};

const submitPendingVote = () => {
  if (!authToken.value) return;
  const pendingTarget = getPendingVoteTarget();
  if (!pendingTarget) return;
  const pendingFood = findFoodByTarget(pendingTarget.type, pendingTarget.id) || createPendingFoodTarget(pendingTarget);
  void submitVote(pendingFood);
};

const getScrollTop = () => window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

const updateScrollState = () => {
  isScrolled.value = getScrollTop() > 12;
};

const scheduleScrollStateUpdate = () => {
  if (scrollFrame) return;
  scrollFrame = window.requestAnimationFrame(() => {
    scrollFrame = 0;
    updateScrollState();
    maybeLoadMoreFoods();
  });
};

const handleHomeClick = () => {
  if (activePage.value !== "home") {
    switchPage("home");
    return;
  }
  if (getScrollTop() <= 12) return;
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const changeCategory = (categoryId: number) => {
  if (activeCategoryId.value === categoryId) return;
  activeCategoryId.value = categoryId;
  dishPage.value = 1;
  isDishFinished.value = false;
  void loadFoods({ reset: true });
};

const changeRankingCategory = (categoryId: number) => {
  if (activeRankingCategoryId.value === categoryId) return;
  activeRankingCategoryId.value = categoryId;
  rankingItems.value = [];
  void fetchRanking();
};

const switchPage = async (page: PageKey) => {
  isSearchActive.value = false;
  activePage.value = page;
  await nextTick();
  window.scrollTo({ top: 0, behavior: "smooth" });
  updateScrollState();
  if (page === "rank") {
    void fetchRanking();
  }
};

const showDetail = async (food: FoodItem) => {
  isSearchActive.value = false;
  searchInputRef.value?.blur();
  selectedFood.value = food;
  activePage.value = "detail";
  if (food.itemType === "merchant") {
    void loadMerchantDishes(food.merchantId || food.id);
  } else {
    merchantDishRequestId += 1;
    isMerchantDishLoading.value = false;
    merchantDishes.value = [];
  }
  await nextTick();
  window.scrollTo({ top: 0, behavior: "smooth" });
  updateScrollState();
};

const openSearch = async () => {
  searchKeyword.value = normalizedSearchKeyword.value;
  isSearchActive.value = true;
  if (searchDraftKeyword.value) {
    void fetchSearchSuggest();
  }
  await nextTick();
  searchInputRef.value?.focus();
};

const handleSearchInput = (event: Event) => {
  searchKeyword.value = (event.target as HTMLInputElement).value;
  scheduleSearchSuggest();
};

const reloadFoodsFromFirstPage = () => {
  dishPage.value = 1;
  isDishFinished.value = false;
  foods.value = [];
  window.scrollTo({ top: 0, behavior: "smooth" });
  void loadFoods({ reset: true });
};

const submitSearch = () => {
  const keyword = searchDraftKeyword.value;
  if (!keyword) {
    closeSearch();
    return;
  }

  const shouldReload = keyword !== normalizedSearchKeyword.value;
  appliedSearchKeyword.value = keyword;
  searchKeyword.value = keyword;
  isSearchActive.value = false;
  searchInputRef.value?.blur();

  if (shouldReload) {
    reloadFoodsFromFirstPage();
  }
};

const closeSearch = () => {
  const shouldReload = Boolean(normalizedSearchKeyword.value);
  isSearchActive.value = false;
  searchInputRef.value?.blur();
  searchKeyword.value = "";
  searchSuggestResults.value = { dishes: [], merchants: [] };
  isSearchSuggestLoading.value = false;
  searchSuggestRequestId += 1;
  if (searchSuggestTimer) {
    window.clearTimeout(searchSuggestTimer);
    searchSuggestTimer = 0;
  }
  appliedSearchKeyword.value = "";

  if (shouldReload) {
    reloadFoodsFromFirstPage();
  }
};

const handleSearchAction = () => {
  if (hasChangedSearchDraft.value) {
    submitSearch();
    return;
  }
  closeSearch();
};

const selectDishSearchResult = async (item: ApiSearchDish) => {
  const selected = mapSearchDishToFood(item);
  isSearchActive.value = false;
  searchInputRef.value?.blur();
  searchSuggestResults.value = { dishes: [], merchants: [] };
  searchSuggestRequestId += 1;
  appliedSearchKeyword.value = "";
  searchKeyword.value = "";
  await showDetail(selected);
};

const selectMerchantSearchResult = (item: ApiSearchMerchant) => {
  void showDetail(mapSearchMerchantToFood(item));
};

const resetHomePicTapCount = () => {
  homePicTapCount = 0;
  lastHomePicTapTime = 0;
  if (homePicTapTimer) {
    window.clearTimeout(homePicTapTimer);
    homePicTapTimer = 0;
  }
};

const closeEasterEgg = () => {
  showEasterEgg.value = false;
};

const handleHomePicTap = () => {
  const now = Date.now();
  if (now - lastHomePicTapTime > 1000) {
    homePicTapCount = 0;
  }

  homePicTapCount += 1;
  lastHomePicTapTime = now;

  if (homePicTapTimer) {
    window.clearTimeout(homePicTapTimer);
  }
  homePicTapTimer = window.setTimeout(resetHomePicTapCount, 1000);

  if (homePicTapCount >= 10) {
    resetHomePicTapCount();
    showEasterEgg.value = true;
  }
};

const handleVoteClick = (food: FoodItem) => {
  const disabledReason = getFoodVoteDisabledReason(food);
  if (disabledReason) {
    showFailToast(disabledReason);
    return;
  }

  if (!authToken.value) {
    setPendingVoteTarget(food);
    redirectToWechatAuth();
    return;
  }
  void submitVote(food);
};

const clearPosterTimers = () => {
  if (posterTimer) {
    window.clearTimeout(posterTimer);
    posterTimer = 0;
  }
  if (posterCountdownTimer) {
    window.clearInterval(posterCountdownTimer);
    posterCountdownTimer = 0;
  }
};

const enterHome = () => {
  if (!showPoster.value) return;
  clearPosterTimers();

  if (!authToken.value) {
    redirectToWechatAuth();
    return;
  }

  showPoster.value = false;
  document.body.style.overflow = originalBodyOverflow;
  void initVotePage();
};

const initVotePage = async () => {
  if (!authToken.value || hasLoadedVoteData) return;

  hasLoadedVoteData = true;
  await Promise.all([fetchStats(), fetchCategories(), fetchMyVote({ silent: true })]);
  await loadFoods({ reset: true });

  void reportVisit();
  submitPendingVote();
};

const startPosterCountdown = () => {
  showPoster.value = true;
  posterCountdown.value = 3;
  document.body.style.overflow = "hidden";
  clearPosterTimers();
  posterCountdownTimer = window.setInterval(() => {
    posterCountdown.value = Math.max(1, posterCountdown.value - 1);
  }, 1000);
  posterTimer = window.setTimeout(enterHome, 3000);
};

onMounted(() => {
  originalBodyOverflow = document.body.style.overflow;
  document.body.style.overflow = "hidden";
  syncAuthFromUrl();
  currentTimestamp.value = Date.now();
  voteCountdownTimer = window.setInterval(() => {
    currentTimestamp.value = Date.now();
  }, 30000);

  startPosterCountdown();

  updateScrollState();
  window.addEventListener("scroll", scheduleScrollStateUpdate, { passive: true });
  document.addEventListener("scroll", scheduleScrollStateUpdate, { passive: true });
});

onBeforeUnmount(() => {
  clearPosterTimers();
  document.body.style.overflow = originalBodyOverflow;
  window.removeEventListener("scroll", scheduleScrollStateUpdate);
  document.removeEventListener("scroll", scheduleScrollStateUpdate);
  if (scrollFrame) {
    window.cancelAnimationFrame(scrollFrame);
  }
  if (voteCountdownTimer) {
    window.clearInterval(voteCountdownTimer);
  }
  if (searchSuggestTimer) {
    window.clearTimeout(searchSuggestTimer);
  }
  resetHomePicTapCount();
});

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "poster-fade" }, {
      default: _withCtx(() => [
        (showPoster.value)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              class: "splash-poster",
              onClick: enterHome
            }, [
              _createElementVNode("img", {
                src: _unref(posterImage),
                alt: "活动开屏海报"
              }, null, 8, _hoisted_1),
              _createElementVNode("div", _hoisted_2, _toDisplayString(posterCountdown.value) + "s", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("main", {
      class: _normalizeClass(['vote-page', `vote-page--${activePage.value}`])
    }, [
      (activePage.value === 'home')
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _unref(homePic),
                  alt: "",
                  class: "home-pic",
                  onClick: _withModifiers(handleHomePicTap, ["stop"])
                }, null, 8, _hoisted_6)
              ])
            ]),
            _createElementVNode("section", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(voteCountdownText)), 1)
              ]),
              _hoisted_11
            ]),
            _createElementVNode("section", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stats), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label,
                  class: "stats-item"
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.label), 1),
                  _createElementVNode("strong", null, _toDisplayString(item.value), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("button", {
              class: "search-box",
              type: "button",
              onClick: openSearch
            }, [
              _createVNode(_component_van_icon, { name: "search" }),
              _createElementVNode("span", null, _toDisplayString(_unref(searchBoxText)), 1)
            ]),
            _createElementVNode("section", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryTabs.value, (tab) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: tab.id,
                    class: _normalizeClass({ active: tab.id === activeCategoryId.value }),
                    type: "button",
                    onClick: ($event: any) => (changeCategory(tab.id))
                  }, _toDisplayString(tab.text), 11, _hoisted_15))
                }), 128))
              ]),
              (foods.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(foods.value, (food) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: food.id,
                        class: "food-card"
                      }, [
                        _createElementVNode("button", {
                          class: "food-img-wrap food-detail-trigger",
                          type: "button",
                          onClick: ($event: any) => (showDetail(food))
                        }, [
                          (food.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: food.image,
                                alt: food.name
                              }, null, 8, _hoisted_18))
                            : (_openBlock(), _createElementBlock("div", _hoisted_19, "暂无图片")),
                          _createElementVNode("span", null, _toDisplayString(food.rank), 1)
                        ], 8, _hoisted_17),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("button", {
                            class: "food-title-btn",
                            type: "button",
                            onClick: ($event: any) => (showDetail(food))
                          }, _toDisplayString(food.name), 9, _hoisted_21),
                          _createElementVNode("strong", null, _toDisplayString(food.votes) + "票", 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass({ 'is-vote-disabled': isFoodVoteDisabled(food) }),
                            disabled: isVoting.value,
                            onClick: ($event: any) => (handleVoteClick(food))
                          }, _toDisplayString(getVoteButtonText(food)), 11, _hoisted_22)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (!isDishLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, "暂无搜索结果"))
                  : _createCommentVNode("", true),
              (isDishLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, "加载中..."))
                : (isDishFinished.value && foods.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, "没有更多了"))
                  : _createCommentVNode("", true)
            ])
          ]))
        : (activePage.value === 'detail')
          ? (_openBlock(), _createElementBlock("section", _hoisted_26, [
              _createElementVNode("header", _hoisted_27, [
                _createElementVNode("h1", null, _toDisplayString(_unref(detailFood).name), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (switchPage('home')))
                }, [
                  _createVNode(_component_van_icon, { name: "revoke" }),
                  _createTextVNode(" 返回首页 ")
                ])
              ]),
              _createElementVNode("section", _hoisted_28, [
                _createElementVNode("button", {
                  class: _normalizeClass(["detail-vote-button", { 'is-vote-disabled': isFoodVoteDisabled(_unref(detailFood)) }]),
                  type: "button",
                  disabled: isVoting.value,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleVoteClick(_unref(detailFood))))
                }, _toDisplayString(getVoteButtonText(_unref(detailFood))), 11, _hoisted_29),
                _createElementVNode("div", _hoisted_30, [
                  (_unref(detailFood).image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(detailFood).image,
                        alt: _unref(detailFood).name
                      }, null, 8, _hoisted_31))
                    : (_openBlock(), _createElementBlock("div", _hoisted_32, "暂无图片")),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(_unref(detailFood).code) + "号", 1),
                    _createElementVNode("h2", null, _toDisplayString(_unref(detailFood).name), 1)
                  ])
                ]),
                (_unref(detailFood).itemType === 'merchant')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_33, [
                      _hoisted_34,
                      (isMerchantDishLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, "加载中..."))
                        : (merchantDishes.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(merchantDishes.value, (item) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: item.id,
                                  type: "button",
                                  class: "merchant-dish-item",
                                  onClick: ($event: any) => (showDetail(item))
                                }, [
                                  (item.image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: item.image,
                                        alt: item.name
                                      }, null, 8, _hoisted_38))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_39, "暂无图片")),
                                  _createElementVNode("span", null, [
                                    _createElementVNode("b", null, _toDisplayString(item.name), 1),
                                    _createElementVNode("em", null, _toDisplayString(item.votes) + "票", 1)
                                  ])
                                ], 8, _hoisted_37))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_40, "暂无菜品"))
                    ]))
                  : _createCommentVNode("", true),
                (_unref(detailFood).desc)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_unref(detailFood).desc), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_42, "打卡点：" + _toDisplayString(_unref(detailFood).name), 1),
                _createElementVNode("p", _hoisted_43, "地址：" + _toDisplayString(_unref(detailFood).address), 1),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", null, [
                    _hoisted_45,
                    _createElementVNode("strong", null, _toDisplayString(_unref(detailFood).votes), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_46,
                    _createElementVNode("strong", null, _toDisplayString(_unref(detailFood).rank), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_47,
                    _createElementVNode("strong", null, _toDisplayString(_unref(detailFood).gap) + " 票", 1)
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_48, [
                (_unref(detailFood).image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(detailFood).image,
                      alt: _unref(detailFood).name
                    }, null, 8, _hoisted_49))
                  : (_openBlock(), _createElementBlock("div", _hoisted_50, "暂无图片"))
              ])
            ]))
          : (activePage.value === 'rank')
            ? (_openBlock(), _createElementBlock("section", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("section", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryTabs.value, (tab) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: tab.id,
                        class: _normalizeClass({ active: tab.id === activeRankingCategoryId.value }),
                        type: "button",
                        onClick: ($event: any) => (changeRankingCategory(tab.id))
                      }, _toDisplayString(tab.text), 11, _hoisted_55))
                    }), 128))
                  ]),
                  _hoisted_56,
                  (rankingItems.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topRankers), (item) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: item.rank,
                            class: _normalizeClass(['top-ranker', `top-ranker--${item.rank}`])
                          }, [
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("span", null, _toDisplayString(item.rank), 1),
                              (item.image)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: item.image,
                                    alt: item.name
                                  }, null, 8, _hoisted_59))
                                : (_openBlock(), _createElementBlock("div", _hoisted_60, "暂无图片"))
                            ]),
                            _createElementVNode("h2", null, _toDisplayString(item.name), 1),
                            _createElementVNode("strong", null, _toDisplayString(item.votes) + "票", 1)
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_61, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(remainingRankers), (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.rank
                      }, [
                        _createElementVNode("span", _hoisted_62, "NO." + _toDisplayString(item.rank), 1),
                        (item.image)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.image,
                              alt: item.name
                            }, null, 8, _hoisted_63))
                          : (_openBlock(), _createElementBlock("div", _hoisted_64, "暂无图片")),
                        _createElementVNode("span", _hoisted_65, _toDisplayString(item.name), 1),
                        _createElementVNode("strong", null, _toDisplayString(item.votes) + "票", 1)
                      ]))
                    }), 128))
                  ]),
                  (isRankingLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, "加载中..."))
                    : (!rankingItems.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, "暂无排行数据"))
                      : _createCommentVNode("", true)
                ])
              ]))
            : (activePage.value === 'rules')
              ? (_openBlock(), _createElementBlock("section", _hoisted_68, [
                  _createElementVNode("section", _hoisted_69, [
                    _createElementVNode("header", _hoisted_70, [
                      _createVNode(_component_van_icon, { name: "notes-o" }),
                      _hoisted_71
                    ]),
                    _hoisted_72
                  ])
                ]))
              : (_openBlock(), _createElementBlock("section", _hoisted_75, [
                  _createElementVNode("section", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("img", {
                        src: _unref(followQrImage),
                        alt: "关注二维码"
                      }, null, 8, _hoisted_78)
                    ]),
                    _hoisted_79
                  ]),
                  _hoisted_80
                ])),
      (activePage.value !== 'detail')
        ? (_openBlock(), _createElementBlock("nav", _hoisted_81, [
            _createElementVNode("a", {
              class: _normalizeClass({ active: activePage.value === 'home' }),
              href: "javascript:void(0)",
              onClick: handleHomeClick
            }, [
              _createVNode(_Transition, {
                name: "nav-swap",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("span", {
                    key: _unref(homeNavKey),
                    class: "nav-content"
                  }, [
                    _createVNode(_component_van_icon, { name: _unref(homeNavIcon) }, null, 8, ["name"]),
                    _createElementVNode("span", null, _toDisplayString(_unref(homeNavText)), 1)
                  ]))
                ]),
                _: 1
              })
            ], 2),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
              return _createElementVNode("a", {
                key: item.key,
                class: _normalizeClass({ active: activePage.value === item.key }),
                href: "javascript:void(0)",
                onClick: ($event: any) => (switchPage(item.key))
              }, [
                _createElementVNode("span", _hoisted_83, [
                  _createVNode(_component_van_icon, {
                    name: item.icon
                  }, null, 8, ["name"]),
                  _createElementVNode("span", null, _toDisplayString(item.text), 1)
                ])
              ], 10, _hoisted_82)
            }), 64))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "search-panel-fade" }, {
        default: _withCtx(() => [
          (isSearchActive.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_84, [
                _hoisted_85,
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("label", _hoisted_87, [
                    _createVNode(_component_van_icon, { name: "search" }),
                    _withDirectives(_createElementVNode("input", {
                      ref_key: "searchInputRef",
                      ref: searchInputRef,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchKeyword).value = $event)),
                      type: "search",
                      inputmode: "search",
                      placeholder: "请输入名称搜索",
                      onInput: handleSearchInput,
                      onKeyup: _withKeys(submitSearch, ["enter"])
                    }, null, 40, _hoisted_88), [
                      [_vModelText, searchKeyword.value]
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "search-cancel",
                    type: "button",
                    onClick: handleSearchAction
                  }, _toDisplayString(_unref(searchActionText)), 1)
                ]),
                _createElementVNode("div", _hoisted_89, [
                  (_unref(searchDraftKeyword) && isSearchSuggestLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, "搜索中..."))
                    : (_unref(searchDraftKeyword) && _unref(hasSearchSuggestResults))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (searchSuggestResults.value.dishes.length)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_91, [
                                _hoisted_92,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchSuggestResults.value.dishes, (item) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: `dish-${item.id}`,
                                    type: "button",
                                    class: "search-result-item",
                                    onClick: ($event: any) => (selectDishSearchResult(item))
                                  }, [
                                    (item.image)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: item.image,
                                          alt: item.name
                                        }, null, 8, _hoisted_94))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_95, "菜")),
                                    _createElementVNode("span", null, [
                                      _createElementVNode("b", null, _toDisplayString(item.name), 1),
                                      _createElementVNode("em", null, _toDisplayString(formatCategoryText(item.category_name || "")), 1)
                                    ])
                                  ], 8, _hoisted_93))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (searchSuggestResults.value.merchants.length)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_96, [
                                _hoisted_97,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchSuggestResults.value.merchants, (item) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: `merchant-${item.id}`,
                                    type: "button",
                                    class: "search-result-item",
                                    onClick: ($event: any) => (selectMerchantSearchResult(item))
                                  }, [
                                    (item.image)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: item.image,
                                          alt: item.name
                                        }, null, 8, _hoisted_99))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_100, "商")),
                                    _createElementVNode("span", null, [
                                      _createElementVNode("b", null, _toDisplayString(item.name), 1),
                                      _createElementVNode("em", null, _toDisplayString(item.address || "点击查看商户"), 1)
                                    ])
                                  ], 8, _hoisted_98))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_unref(searchDraftKeyword))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, "暂无搜索结果"))
                        : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "egg-popup-fade" }, {
        default: _withCtx(() => [
          (showEasterEgg.value)
            ? (_openBlock(), _createElementBlock("section", {
                key: 0,
                class: "egg-popup",
                onClick: closeEasterEgg
              }, [
                _createElementVNode("div", {
                  class: "egg-card",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("button", {
                    class: "egg-close",
                    type: "button",
                    "aria-label": "关闭彩蛋",
                    onClick: closeEasterEgg
                  }, [
                    _createVNode(_component_van_icon, { name: "cross" })
                  ]),
                  _hoisted_102,
                  _hoisted_103,
                  _hoisted_104
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2), [
      [_vShow, !showPoster.value]
    ])
  ], 64))
}
}

})